export default __webpack_public_path__ + "locales/sr-Cyrl-RS/DeleteProfileEverDialog.json?hash=dba0319b666ec6cce4ae6aa77e90f0c1";